import { z } from 'zod';
import { paginationSchema } from './api.js';
import { PRIORITIES, TASK_STATUSES } from './enums.js';
/**
 * Tasks — the internal to-do board, GBV-DEV-2026-001 Section 09.
 *
 * Not the same thing as an Appointment (a commitment to a client at a time) or
 * a follow-up date on a lead (a prompt to call). A task is work the team owes
 * itself, and its only audience is the team.
 */
export const TASK_STATUS_LABELS = {
    TODO: 'To do',
    IN_PROGRESS: 'In progress',
    BLOCKED: 'Blocked',
    DONE: 'Done',
};
/** The board's working columns. DONE is the outcome, not a lane to plan in. */
export const TASK_BOARD_STATUSES = ['TODO', 'IN_PROGRESS', 'BLOCKED'];
/** Re-exported under a task-shaped name; the values live in enums.ts. */
export const TASK_PRIORITIES = PRIORITIES;
export const TASK_PRIORITY_LABELS = {
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
    URGENT: 'Urgent',
};
export const taskCreateSchema = z.object({
    title: z.string().trim().min(3, 'Say what needs doing.').max(200),
    description: z.string().trim().max(2000).optional().or(z.literal('')),
    status: z.enum(TASK_STATUSES).default('TODO'),
    priority: z.enum(TASK_PRIORITIES).default('MEDIUM'),
    assigneeId: z.string().cuid().nullable().optional(),
    dueAt: z.coerce.date().nullable().optional(),
});
export const taskUpdateSchema = taskCreateSchema.partial();
/**
 * Moving a card. `afterId` and `beforeId` are the cards it was dropped
 * between — the server works out the position from them, because the browser
 * does not know what else has moved since it last read the board.
 */
export const taskMoveSchema = z.object({
    status: z.enum(TASK_STATUSES),
    afterId: z.string().cuid().nullable().optional(),
    beforeId: z.string().cuid().nullable().optional(),
});
export const taskListQuery = paginationSchema.extend({
    status: z.enum(TASK_STATUSES).optional(),
    assigneeId: z.string().cuid().optional(),
    priority: z.enum(TASK_PRIORITIES).optional(),
    search: z.string().trim().max(120).optional(),
    /** Only what is already late. */
    overdueOnly: z.coerce.boolean().optional(),
});
//# sourceMappingURL=task.schema.js.map